import StickyButtonComponent from "./StickyButtonComponent";

export default StickyButtonComponent;